<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <div style="font-size: 20px; font-weight: 500">基本信息</div>
        <a-form-item
          label="UserId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="64"
            placeholder="请输入用户UserId"
            v-decorator.trim="['userId', validatorRules.userId]"
            :readOnly="!!model.userid"
          />
        </a-form-item>

        <template v-if="!model.id">
          <a-form-item
            label="成员名称"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              :max-length="64"
              type="text"
              placeholder="请输入成员名称"
              v-decorator="['name', validatorRules.name]"
            />
          </a-form-item>
        </template>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group v-model="view.type" :disabled="true">
            <a-radio value="1"> 已激活 </a-radio>
            <a-radio value="2"> 已禁用 </a-radio>
            <a-radio value="4"> 未激活 </a-radio>
            <a-radio value="5"> 退出企业 </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <UploadImage
            :accept="'.jpg, .png'"
            :imgUrl="fileList.fileUrl"
            @handleFileList="
              (e) => {
                getFileList(e);
              }
            "
            v-decorator="['avatar_mediaid']"
          />
        </a-form-item>

        <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['gender', {}]"
            placeholder="请选择性别"
            :getPopupContainer="(target) => target.parentNode"
          >
            <a-select-option value="1">男</a-select-option>
            <a-select-option value="2">女</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            :max-length="64"
            placeholder="请输入邮箱（若绑定了腾讯企业邮箱的企业微信，需在腾讯企业邮箱中修改邮箱）"
            v-decorator="['email', validatorRules.email]"
          />
        </a-form-item>

        <a-form-item
          label="手机号码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="11"
            placeholder="请输入手机号码 (若成员已激活企业微信，需成员自行修改)"
            v-decorator="['mobile', validatorRules.mobile]"
            :readOnly="view.type === '1'"
          />
        </a-form-item>

        <a-form-item
          label="座机号码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="32"
            placeholder="请输入座机号码"
            v-decorator="['telephone', validatorRules.telephone]"
          />
        </a-form-item>

        <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            :max-length="128"
            placeholder="请输入地址"
            v-decorator="['address', {}]"
            :maxLength="128"
          />
        </a-form-item>

        <!-- 部门 -->
        <div style="font-size: 20px; font-weight: 500; margin-top: 40px">
          部门
        </div>
        <a-form-item
          label="部门分配"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="!departDisabled"
        >
          <a-input-search
            placeholder="点击选择部门"
            v-decorator="[
              'checkedDepartNameString',
              validatorRules.checkedDepartNameString,
            ]"
            @search="onSearch"
          >
            <a-button slot="enterButton" icon="search">选择</a-button>
          </a-input-search>
        </a-form-item>

        <a-form-item label="职务" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-position
            placeholder="请选择职务"
            :multiple="false"
            v-decorator="['position', {}]"
          />
        </a-form-item>

        <a-form-item label="身份" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group v-model="identity" @change="identityChange">
            <a-radio value="0">普通用户</a-radio>
            <a-radio value="1">上级</a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- 对外信息 -->
        <div style="font-size: 20px; font-weight: 500; margin-top: 40px">
          对外信息
        </div>
        <a-form-item
          label="对外职务"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="12"
            placeholder="请输入职务"
            v-decorator="['external_position', {}]"
            :maxLength="12"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <depart-window ref="departWindow" @ok="modalFormOk"></depart-window>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit()" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import moment from 'moment';
// 引入搜索部门弹出框的组件
import departWindow from './DepartWindow';
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import {
  queryUserRole,
  editCusList,
  getCorpShortNameFromSysDict,
  editCusSubmit,
  createCusSubmit,
  departmentList,
  getFileIOByMediaId,
} from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';
import UploadImage from '@/components/common/UploadImage';
export default {
  name: 'UserModal',
  components: {
    departWindow,
    JSelectPosition,
    UploadImage,
  },
  data() {
    return {
      companyName: '',
      view: {
        type: '4',
        identity: [],
      },
      miniRadio: '2',
      webRadio: '1',
      departDisabled: false, //是否是我的部门调用该页面
      roleDisabled: false, //是否是角色维护调用该页面
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      selectedDepartKeys: [], //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [], // 保存部门的名称 =>title
      checkedDepartNameString: '', // 保存部门的名称 =>title
      resultDepartOptions: [],
      userId: '', //保存用户id
      disableSubmit: false,
      userDepartModel: { userId: '', departIdList: [] }, // 保存SysUserDepart的用户部门中间表数据需要的对象
      dateFormat: 'YYYY-MM-DD',
      validatorRules: {
        checkedDepartNameString: {
          rules: [{ required: true, message: '请输入部门的名称' }],
        },
        userId: {
          rules: [
            { required: true, message: '请输入UserId!' },
            // {  pattern: /[^\u4e00-\u9fa5]/g,message: '请输入字母或数字!' },
            {
              pattern: /[0-9a-zA-Z][0-9a-zA-Z_\-@.]{0,63}/,
              message:
                '只能由数字、字母和“_-@.”四种字符组成，且第一个字符必须是数字或字母!',
            },
          ],
        },
        name: {
          rules: [{ required: true, message: '请输入成员名称!' }],
        },
        mobile: {
          rules: [
            {
              required: true,
              pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: '请输入正确的手机号码!',
            },
          ],
        },
        telephone: {
          rules: [
            {
              pattern: /^0\d{2,3}-[1-9]\d{6,7}$/,
              message: '请输入正确的座机号码',
            },
          ],
        },
        email: {
          rules: [
            {
              pattern:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: '请输入正确的邮箱!',
              trigger: 'blur',
            },
          ],
        },
      },
      departIdShow: false,
      departIds: [], //负责部门id
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      flag: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      status: 4,
      uploadLoading: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      url: {
        // fileUpload: process.env.VUE_APP_GATEWAY_URL + process.env.VUE_APP_CMS_SYSTEM+"/sys/common/upload",
        // userWithDepart: process.env.VUE_APP_CMS_SYSTEM + "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
        // userId:process.env.VUE_APP_CMS_SYSTEM + "/sys/user/generateUserId", // 引入生成添加用户情况下的url
        // syncUserByUserName:process.env.VUE_APP_CMS_SYSTEM + "/process/extActProcess/doSyncUserByUserName",//同步用户到工作流
      },
      identity: '0',
      // external_attr_type: "0",
      external_attr: [
        {
          name: '',
          type: '1',
          text: {
            value: '',
          },
          web: {
            url: '',
            title: '',
          },
          miniprogram: {
            appid: '',
            title: '',
            pagepath: '',
          },
        },
        {
          name: '',
          type: '2',
          text: {
            value: '',
          },
          web: {
            url: '',
            title: '',
          },
          miniprogram: {
            appid: '',
            title: '',
            pagepath: '',
          },
        },
      ],
      avatar_mediaid: '',
      avatarUrl: '',
      fileList: {},
    };
  },

  created() {
    this.getCompanyName();
  },
  computed: {
    isValue() {
      return this.external_attr[0].type.toString() === '0';
    },
    isWeb() {
      return this.external_attr[0].type.toString() === '1';
    },
    isMiniprogram() {
      return this.external_attr[0].type.toString() === '2';
    },
    isValue2() {
      return this.external_attr[1].type.toString() === '0';
    },
    isWeb2() {
      return this.external_attr[1].type.toString() === '1';
    },
    isMiniprogram2() {
      return this.external_attr[1].type.toString() === '2';
    },
  },
  // inject: ['reload'],
  methods: {
    //获取企业简称
    getCompanyName() {
      getCorpShortNameFromSysDict().then((res) => {
        if (res.success) {
          this.companyName = res.result;
        }
      });
    },
    initialRoleList(userId) {
      if (!userId) {
        return;
      }
      this.model.userid = userId;
      let that = this;
      editCusList({ userId: userId }).then((res) => {
        if (res.success) {
          let result = res.result;
          that.form.setFieldsValue({
            userId: result.userid,
            name: result.name,
            gender:
              result.gender == '1' || result.gender == '2'
                ? result.gender
                : undefined,
            email: result.email,
            mobile: result.mobile,
            telephone: result.telephone,
            address: result.address,
            position: result.position,
            external_position: result.external_position,
          });
          if (
            result.external_profile &&
            result.external_profile.external_attr != null &&
            result.external_profile.external_attr.length > 0
          ) {
            if (result.external_profile.external_attr.length === 1) {
              var external_attr = [];
              external_attr = res.result.external_profile.external_attr;
              if (external_attr[0].web != null) {
                that.external_attr[0] = external_attr[0];
              } else {
                that.external_attr[1] = external_attr[0];
              }
            } else {
              that.external_attr = res.result.external_profile.external_attr;
            }
          }
          // that.identity = res.result.is_leader_in_dept[0];
          //身份为上级显示负责部门，否则不显示
          if (
            res.result.is_leader_in_dept &&
            res.result.is_leader_in_dept[0] == '0'
          ) {
            that.identity = '0';
            that.departIdShow = true;
          } else {
            that.identity = '1';
            that.departIdShow = false;
          }
          that.selectedDepartKeys = res.result.department;
          that.checkedDepartNameString = res.result.main_department;
          // that.view.type = res.result.status+''
          // console.log(that.view.type)

          that.checkedDepartKeys = res.result.department;
          this.form.setFieldsValue({
            checkedDepartNameString: res.result.main_department,
            avatar_mediaid: res.result.avatar_mediaid,
          });
          this.fileList = {
            fileName: res.result.avatar_mediaid,
            fileUrl: res.result.avatar,
          };
          // that.fileList = res.result.avatar
        } else {
          console.log(res.userid);
        }
      });
    },
    refresh() {
      this.selectedDepartKeys = [];
      this.checkedDepartKeys = [];
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.userId = '';
      this.resultDepartOptions = [];
      this.departId = [];
      this.departIdShow = false;
    },
    add() {
      this.refresh();
      this.flag = true;
      this.edit({ activitiSync: '1' });
    },
    edit(record) {
      debugger;
      let that = this;
      //加载部门
      that.fileList = {
        fileName: '',
        fileUrl: '',
      };
      that.initialRoleList(record.userid);
      that.view.type = record.status ? record.status + '' : '4';
      that.userId = record.userid ? record.userid : '';
      that.visible = true;
      that.status = record.status ? record.status : 4;
      this.external_attr = [
        {
          name: '',
          type: '1',
          text: {
            value: '',
          },
          web: {
            url: '',
            title: '',
          },
          miniprogram: {
            appid: '',
            title: '',
            pagepath: '',
          },
        },
        {
          name: '',
          type: '2',
          text: {
            value: '',
          },
          web: {
            url: '',
            title: '',
          },
          miniprogram: {
            appid: '',
            title: '',
            pagepath: '',
          },
        },
      ];
      that.form.resetFields();
      // 调用查询用户对应的部门信息的方法
      that.checkedDepartKeys = [];
      that.loadCheckedDeparts();
    },
    //
    loadCheckedDeparts() {
      let that = this;
      if (!that.userId || that.userId == '') {
        return;
      }
      that.checkedDepartNames = [];
      var depart = [];
      var departId = [];
      departmentList().then((res) => {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            // this.selectedDepartKeys.push(res.result[i].key);
            this.checkedDepartNames.push(res.result[i].title);
            this.checkedDepartNameString = this.checkedDepartNames.join(',');
            //新增部门选择，如果上面部门选择后不为空直接付给负责部门
            depart.push({
              key: res.result[i].key,
              title: res.result[i].title,
            });
            this.departIds.push(res.result[i].key);
          }

          console.log(this.selectedDepartKeys);
        }
      });
      that.resultDepartOptions = depart;
      //判断部门id是否存在，不存在择直接默认当前所在部门
      if (this.model.departIds) {
        this.departIds = this.model.departIds.split(',');
      } else {
        this.departIds = departId;
      }
      that.userDepartModel.departIdList = that.checkedDepartKeys;
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
      this.userDepartModel = { userId: '', departIdList: [] };
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.checkedDepartKeys = [];
      this.selectedDepartKeys = [];
      this.resultDepartOptions = [];
      this.departIds = [];
      this.departIdShow = false;
      this.identity = '0';
      this.flag = false;
    },
    moment,
    handleSubmit() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(values, this.model);
          console.log(this.model);
          formData.department = that.selectedDepartKeys;

          formData.userid = formData.userId;
          // formData.external_profile.external_attr = this.external_attr
          formData.avatar_mediaid = this.fileList.fileName || null; //this.avatar_mediaid || null;
          formData.avatar = this.fileList.fileUrl || null; //this.avatarUrl || null;
          let is_leader = parseInt(this.identity);
          let arrTemp = that.selectedDepartKeys; //this.checkedDepartNameString.split(',');

          let dept = [];
          arrTemp.forEach((ele) => {
            dept.push(is_leader);
          });
          formData.is_leader_in_dept = dept;
          formData.status = this.status;
          if (that.userId && that.userId != '') {
            editCusSubmit(formData).then((res) => {
              that.confirmLoading = false;
              if (res.code == 0 || res.success) {
                that.close();
                this.$emit('searchReset');
                // that.reload();
                that.$message.success('修改成功！');
              } else {
                that.$message.error(res.message);
              }
            });
          } else {
            createCusSubmit(formData).then((res) => {
              that.confirmLoading = false;
              if (res.success) {
                that.close();
                this.$emit('searchReset');
                // that.reload();
                that.$message.success('新增成功！');
              } else {
                that.$message.error(res.message);
              }
            });
          }
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    // 搜索用户对应的部门API
    onSearch() {
      console.log(this.checkedDepartKeys);
      this.$refs.departWindow.add(this.checkedDepartKeys, this.userId);
    },
    // 获取用户对应部门弹出框提交给返回的数据
    modalFormOk(formData) {
      console.log(formData);
      this.checkedDepartNames = [];
      this.selectedDepartKeys = [];
      this.checkedDepartNameString = '';
      this.userId = formData.userId;
      this.userDepartModel.userId = formData.userId;
      this.departIds = [];
      this.resultDepartOptions = [];
      var depart = [];
      //this.selectedDepartKeys = formData.departIdList
      // departmentList().then((res)=>{
      //   if(res.success){
      //     for (var i = 0;i<res.result.length;i++){
      for (var i = 0; i < formData.departIdList.length; i++) {
        this.selectedDepartKeys.push(formData.departIdList[i].key);
        this.checkedDepartNames.push(formData.departIdList[i].title);
        if (this.checkedDepartNames.length > 1) {
          this.checkedDepartNameString = this.checkedDepartNames.join(',');
        } else {
          this.checkedDepartNameString = this.checkedDepartNames[0];
        }

        //新增部门选择，如果上面部门选择后不为空直接付给负责部门
        depart.push({
          key: formData.departIdList[i].key,
          title: formData.departIdList[i].title,
        });
        this.departIds.push(formData.departIdList[i].key);
      }
      this.form.setFieldsValue({
        checkedDepartNameString: this.checkedDepartNameString,
      });
      //     }
      //   }
      // });
      this.resultDepartOptions = depart;
      this.userDepartModel.departIdList = this.selectedDepartKeys;
      this.checkedDepartKeys = this.selectedDepartKeys; //更新当前的选择keys
    },
    identityChange(e) {
      this.identity = e.target.value;
      if (e.target.value === '1') {
        this.departIdShow = false;
      } else {
        this.departIdShow = true;
      }
    },
    getFileList(file) {
      this.fileList = file;
      this.form.setFieldsValue({
        avatar_mediaid: process.env.VUE_APP_FILE_PATH + file.fileName,
      });
    },
  },
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
